namespace MWY {

    export interface IReadOnly {
        get_readOnly(): boolean;
        set_readOnly(value: boolean): void;
    }

    @MWY.Decorators.registerInterface('MWY.IReadOnly')
    export class IReadOnly {
    }
}